import React, { useEffect, useState } from 'react';
import IconButton from 'material-ui/IconButton';
import HistoryIcon from 'material-ui/svg-icons/action/history';
import Status from '../List/Status';
import Topics from '../List/Topics';
import { Chip } from 'material-ui';
import TextDisplayer from './TextDisplayer';
import Attachments from './Attachments';
import History from './History';
import Comments from './comments/Comments';

export default function IssueManagement({ issue: _issue, handleChangeIssue }) {
    const [historyOpen, setHistoryOpen] = useState(false);
    const [issue, setIssue] = useState({});

    useEffect(() => {
        setIssue({
            ..._issue,
        });
    }, [_issue]);

    const handleChangeStatus = (newStatus) => {
        handleChangeIssue({_id: issue._id, status: newStatus});
    };

    const handleHistoryOpen = () => {
        setHistoryOpen(!historyOpen);
    };

    return (
        <div className='management'>
            <History 
                open={historyOpen}
                handleHistoryOpen={handleHistoryOpen}
                history={issue.statusHistory}
            />
            <div className='management-children'>
                <div className='info-basic'>
                    <div className='nonChange'>
                        <span className='ref'>Ref: {issue.refNo}</span>
                        <IconButton
                            onClick={() => setHistoryOpen(!historyOpen)}
                        >
                            <HistoryIcon 
                                style={{ padding: '8px' }}
                                color='#b3b3b3'
                            />
                        </IconButton>
                        <span>Reporter: {issue.addedBy && issue.addedBy.email}</span>
                    </div>
                    <div className='change'>
                        <Status 
                            className='status'
                            style={{ height: '20px' }}
                            handleChangeStatus={handleChangeStatus} 
                            status={issue.status} 
                        />
                    </div>
                </div>
                <div className='info-topics'>
                    <span className='name'>TOPICS: </span>
                    {
                        issue.topics ? 
                            <Topics topics={issue.topics}/> : null
                    }
                </div>
                <TextDisplayer text={issue.text || ''} />
                <Attachments attachments={issue.attachments || []} />
                <Comments />
            </div>
        </div>
    );
}



// WEBPACK FOOTER //
// ./app/components/Issues/Issue/IssueManagement.jsx